import module from 'nominas/donaciones/module.js'
import template from './template.html'
import * as moment from 'moment'

export class NominasDonacionesExportarComponent {
  data
  onClose
  options = {
    filename: '',
  }

  constructor ($export) {
    this.$export = $export
  }

  $onInit () {
    this.options.filename = `${this.data.ID_Nomina} - Donaciones-Charities - ${moment(this.data.Fecha_Final).format('YYYYMMDD')}`
  }

  cerrar () {
    this.onClose({$event: {detail: null}})
  }

  exportar () {
    const pages = [{
      name: 'Donaciones',
      details: [
        {label: 'Empresa: ' + this.data.Empresa, cell: 'D1'},
        {label: 'Nomina: ' + this.data.ID_Nomina, cell: 'D2'},
        {label: 'Moneda: ' + this.data.Moneda, cell: 'D3'},
        {label: 'Fecha: ' + moment(this.data.Fecha).format('YYYY-MM-DD'), cell: 'I1'},
        {label: 'Fecha inicial: ' + moment(this.data.Fecha_Inicial).format('YYYY-MM-DD'), cell: 'I2'},
        {label: 'Fecha final: ' + moment(this.data.Fecha_Final).format('YYYY-MM-DD'), cell: 'I3'},
        {label: 'Fecha de pago: ' + moment(this.data.Fecha_Pago).format('YYYY-MM-DD'), cell: 'I4'},
      ],
      columns: [
        {label: 'Emp.', format: {align: 'center', width: 4}},
        {label: 'Empleado', format: {align: 'center', width: 7}},
        {label: 'Nombre', format: {width: 40}},
        {label: 'Sala', format: {width: 20}},
        {label: 'Folio', format: {width: 10}},
        {label: 'Fecha', format: {type: 'date', width: 10}},
        {label: 'Cn.', format: {align: 'center', width: 5}},
        {label: 'Importe', format: {type: 'currency', align: 'right', width: 10}, totalize: true},
        {label: 'Notas', format: {width: 50}},
      ],
      options: {
        logo: {
          filename: '/api/export/images/FAN-logo.png',
          title: 'FAN Consultores',
          cell: 'A1',
        },
        show_grid: false,
        fixed_column: 'E8',
      },
      data: this.data.Servicios.map((item) => [
        item.ID_Empresa,
        item.ID_Empleado,
        item.Empleado,
        item.Sala,
        item.Folio,
        (item.Fecha_Movimiento).format('YYYY-MM-DD'),
        '15',
        item.Importe,
        item.Notas,
      ]),
    }]

    this.$export.excel(this.options.filename, pages)
    this.cerrar()
  }
}

module.component('nominasDonacionesExportar', {
  controller: NominasDonacionesExportarComponent,
  template,
  bindings: {
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/donaciones/components/exportar/component.js